import CoachDetailsView from './CoachDetailsView'
export default CoachDetailsView
